import { Progress, ProgressProps } from '@chakra-ui/react';
import React from 'react';

export type QProgressProps = ProgressProps;

export const QProgress: React.FC<QProgressProps> = (props) => {
  return <Progress borderRadius="sm" {...props} />;
};
